// extracted by mini-css-extract-plugin
export default {"overlay":"JA-z","bodyOpen":"KA-z","content":"LA-z","header":"MA-z","close":"NA-z","closeNoHeading":"OA-z"};